import React from 'react'
import { connect } from 'react-redux'
import { mean, max, min, keys } from 'lodash'
import Dimensions from 'react-dimensions'
import { Origin } from 'redux-tooltip';

import './index.css'

var d3 = require('d3')

const Oline = Origin.wrapBy('line')

class DistributionChart extends React.PureComponent {
  render() {
    const { distributionData, indicators, countries,
        indicator, countryCode, height=50, containerWidth } = this.props

    const countryCodes = keys(distributionData)
    const plotData = countryCodes.map(country => (
      distributionData[country] ? {
        country,
        ...distributionData[country]
      } : null
    )).filter(datum => datum && datum.v !== null)

    if(!plotData.length){
      return <div>&nbsp;</div>
    }

    //SCALE direction depends on indicator "rankDirection"
    let rangeForIndicator;
    if(indicators[indicator].rankDirection === "0"){
      rangeForIndicator = [1, containerWidth-1]
    } else {
      rangeForIndicator = [containerWidth-1, 1]
    }
    const plotDataValues = plotData.map(datum => datum.v)
    //const scale = d3.scaleLinear().domain(indicators[indicator].domain).range(rangeForIndicator)
    const scale = d3.scaleLinear().domain([min(plotDataValues), max(plotDataValues)]).range(rangeForIndicator)

    let countryValue, countryValueScaled
    // let countryValueIdx=-1
    if(countryCode){
      // countryValueIdx =  findIndex(dataByIndicator, datum => datum.country === countryCode)
      // if(countryValueIdx !== -1){
      //     countryValue = dataByIndicator[countryValueIdx]
      //     countryValueScaled = scale(countryValue.v)
      // }
      countryValue = distributionData[countryCode]
      countryValueScaled = scale(countryValue.v)
    }

    const avgValue = mean(plotDataValues).toFixed(2);
    const avgValueScaled = scale(avgValue)

    return (

        <svg height={height} className="DistributionChart__svg">
          {/* contour rectangle */}
          <g>
            <rect height={height} width={containerWidth-1} className="DistributionChart__rect"></rect>
          </g>
          <g>
            { plotData.map((datum, i) => {
              const scaledX = scale(datum.v)
              return (
                <Oline key={i} x1={scaledX} x2={scaledX} y1={0} y2={height} className="line-others" content={`${countries[datum.country]}: ${datum.v} (${datum.y})`}/>
              )
            }) }
          </g>
          <g>
            { countryValueScaled !== undefined  && (
            <Oline x1={countryValueScaled} x2={countryValueScaled} y1={0} y2={height} className="line-selected" content={`${countries[countryCode]}: ${countryValue.v} (${countryValue.y})`}/>
            )}
          </g>
          <g>
            <Oline x1={avgValueScaled} x2={avgValueScaled} y1={0} y2={height} className="line-avg" content={`Average: ${avgValue}`}/>
          </g>
        </svg>
    )
  }
}


const mapStateToProps = (state, props) => ({
  //dataByIndicator : getLastDataByIndicator(state, props),
  indicators: state.indicators,
  countries: state.countries,
})

export default connect(mapStateToProps)(Dimensions({containerStyle:{width:'100%', height:'100%'}})(DistributionChart))



// WEBPACK FOOTER //
// ./src/components/DistributionChart/index.js